export default "__VITE_ASSET__BKMOtbH$__"